import React, { useState } from 'react';
import MoverService from '../../../services/MoverService';
import DatePicker from 'react-date-picker';
import { useSelector } from 'react-redux';
import { parseISO } from 'date-fns';
import AuthenticatedComponent from '../../AuthenticatedComponent';

function CreateMoverComponent(props) {
    const _apartments = useSelector(state => state.apartments._apartments);
    const [addNew, setAddNew] = useState(false);
    const [mover, setMover] = useState(props.mover || {});
    const [number, setNumber] = useState(null);

    const toggleAddNew = () => {
        setAddNew(!addNew);
    };

    const save = () => {
        var newApartment = _apartments.filter(x => x.number === parseInt(number));

        MoverService.create({ ...mover, apartment_id: newApartment[0].id });

        toggleAddNew();
    };

    return (
        <React.Fragment>{!addNew ?
            <tr>
                <td colSpan="9">
                    <button className="btn btn-primary pull-right" onClick={toggleAddNew}>Tilføj</button>
                </td>
            </tr>
            :
            <tr>
                <td colSpan="9">
                    <div className="panel panel-default">
                        <div className="panel-body textAlignLeft">
                            <div className="col-md-12">
                                <form className="apartmentForm" id="apartmentForm" onSubmit={save}>
                                    <div className="row">
                                        <div className="col-md-4 panelRowPadding ">
                                            <div>
                                                <label>Overtagelsesdato</label>
                                            </div>
                                            <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    value={mover.takeover_date ? new Date(parseISO(mover.takeover_date)) : null}
                                                    onChange={date => { setMover({ ...mover, takeover_date: date.toISOString() }) }}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="col-md-4 panelRowPadding ">
                                            <div>
                                                <label>Andels nr.</label>
                                            </div>
                                            <input className="form-control" name="type" value={number} onChange={(event) => setNumber(event.target.value)} type="text" />
                                        </div>
                                        <div className="col-md-4 panelRowPadding ">
                                            <div>
                                                <label>Sælgers navn</label>
                                            </div>
                                            <input className="form-control" name="type" value={mover.seller_name} onChange={(event) => setMover({ ...mover, seller_name: event.target.value })} type="text" />
                                        </div>
                                    </div>
                                        <div className="row">
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers addresse</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_address || ''} onChange={(event) => setMover({ ...mover, seller_address: event.target.value })} type="text" />
                                            </div>
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers by</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_suburb || ''} onChange={(event) => setMover({ ...mover, seller_suburb: event.target.value })} type="text" />
                                            </div>
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers postnummer</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_postcode || ''} onChange={(event) => setMover({ ...mover, seller_postcode: event.target.value })} type="text" />
                                            </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-4 panelRowPadding ">
                                            <div>
                                                <label>Sælgers e-mail</label>
                                            </div>
                                            <input className="form-control" name="type" value={mover.seller_email} onChange={(event) => setMover({ ...mover, seller_email: event.target.value })} type="text" />
                                        </div>
                                        <div className="col-md-4 panelRowPadding ">
                                            <div>
                                                <label>Købers navn</label>
                                            </div>
                                            <input className="form-control" name="type" value={mover.buyer_name} onChange={(event) => setMover({ ...mover, buyer_name: event.target.value })} type="text" />
                                        </div>
                                        </div>
                                    <div className="row">
                                        <div className="col-md">
                                            <button className="btn btn-primary" type="submit" >Opret</button>
                                            <button className="btn btn-primary ml-2" onClick={toggleAddNew}>Afbryd</button>
                                        </div>
                                    </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>}
        </React.Fragment>
    );
}

export default AuthenticatedComponent(CreateMoverComponent)